export default {
  // 表单数据
  ruleForm: {
    unit: "",
    account: "",
    pwd: "",
    baseReqDto: "",
    phone: "",
    message: ""
  },

  // 用户登录信息
  binyi_cms_loginInfo: {role: {}},

  //修改密码
  pasResForm: {
    "adminId": 0,
    "oldPwd": "",
    "newPwd": ""
  },

  //图片验证码
  imgCodePath: '',
  loginSucceed:false

}



// WEBPACK FOOTER //
// ./src/store/modules/UserLogin/state.js